import request from '@/utils/request'

const addressURl = {
    distributionList: '/quick-business-communication/list',
    distributionCreate: '/quick-business-communication/create',
    distributionUpdate: '/quick-business-communication/update',
    distributionDelete: '/quick-business-communication/delete',
    distributionDetail: '/quick-business-communication/details',
}

// 快商通-列表
export function distributionList(params) {
    return request({
        url: addressURl.distributionList,
        method: 'get',
        params
    })
}

// 快商通-创建
export function distributionCreate(data) {
    return request({
        url: addressURl.distributionCreate,
        method: 'post',
        data
    })
}

// 快商通-更新
export function distributionUpdate(data) {
    return request({
        url: addressURl.distributionUpdate,
        method: 'post',
        data
    })
}

// 快商通-删除
export function distributionDelete(params) {
    return request({
        url: addressURl.distributionDelete,
        method: 'get',
        params
    })
}
// 快商通-详情
export function distributionDetail(params) {
    return request({
        url: addressURl.distributionDetail,
        method: 'get',
        params
    })
}

export default {
    distributionList,
    distributionCreate,
    distributionUpdate,
    distributionDelete,
    distributionDetail,
}
